import { useSuspenseQuery } from '@apollo/client';
import { GET_GATE_RENDERER_DATA } from '../graphql/queries/getGateRendererData';
import { getMovementFragmentData } from '../utils/getMovementFragmentData';

export type UseGateCommonDataQueryOptions = {
  fetchPolicy?: 'no-cache';
};

export type GateCommonData = ReturnType<typeof useGateData>;

export const useGateData = (gateId: string, queryOptions?: UseGateCommonDataQueryOptions) => {
  const { data } = useSuspenseQuery(GET_GATE_RENDERER_DATA, {
    variables: { gateId },
    ...queryOptions,
  });

  const lastPosition = data.gate.movements2.lastPosition ?? null;
  const movements = data.gate.movements2.history.map(getMovementFragmentData);
  const {
    activeMovement: activeMovementFragment,
    lastMovement: lastMovementFragment,
    operatingState,
    unit,
    precision,
  } = data.gate.movements2;
  const lastMovement = lastMovementFragment ? getMovementFragmentData(lastMovementFragment) : null;
  const activeMovement = activeMovementFragment
    ? getMovementFragmentData(activeMovementFragment)
    : null;

  return {
    operatingState,
    lastPosition,
    movements,
    activeMovement,
    lastMovement,
    unit,
    precision,
  };
};
